export class SessionToken{
     sessionUID : string;
  
}